// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1bzVh","icon":"styles-module__icon___G5Iid","title":"styles-module__title___37jvX","text":"styles-module__text___1IR-S"};